import { format, isValid } from 'date-fns';
import { FC } from 'react';

import { parseDate } from '../../utils/datetime';

interface PublishedAtProps {
  date: string;
}

export const PublishedAt: FC<PublishedAtProps> = ({ date }) => {
  const day = parseDate(date);
  if (!day || isValid(new Date(day)) === false) {
    return null;
  }

  return (
    <time className="inline capitalize" dateTime={date}>
      {format(day, 'MMMM dd, yyyy')}
    </time>
  );
};
